import { navigate } from '@reach/router';

export const navigateTo = (destinationURL: string) => () => navigate(destinationURL);
